import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import StorefrontService from '../../services/Storefront';
import { useStorefrontSettings } from '../../hooks/StorefrontSettingsContext';

const StorefrontPersona = props => {

    const storefrontConfig = useStorefrontSettings();
    const [isCustAdmin] = useState((props.currentUser.persona.name !== "Administrator" && props.currentUser.persona.name !="StorefrontAdministrator"));
    const [personaList, setPersonaList] = useState(props.personaList || []);
    const [selectedStorefront, setSelectedStorefront] = useState((isCustAdmin) ? getUserStorefrontValue() : props.currentStorefront || {});
    const [selectedPersona, setSelectedPersona] = useState(props.currentPersona || {});
    const [storefrontOptions] = useState(getOptions() || []);

    useEffect(() => {
        let storefront = storefrontConfig.getStorefrontById(selectedStorefront.value);
        if (storefront && storefront.number) {
            fetchPersonaList(storefront.number);
        }
    }, [selectedStorefront]);

    function getUserStorefrontValue() {
        var s = storefrontConfig.getStorefrontById(props.currentUser.storefrontId);

        return { value: s.id, label: s.displayName };
    }

    function getOptions() {
        var result = [];

        storefrontConfig.storefrontList.forEach((s) => {
            if (s.number !== '00000') {
                result.push({ value: s.id, label: s.displayName });
            }
        });

        return result.sort((a, b) => a['label'].localeCompare(b['label']));
    }

    function fetchPersonaList(storefrontNumber) {
        StorefrontService.getSelectablePersonas(storefrontNumber).then((res) => {
            // populate persona list
            var list = [];
            res.forEach((p) => {
                if ((isCustAdmin && (p.displayName !== "Administrator" && p.displayName !="Storefront Administrator")) || (props.currentUser.persona.name === "Administrator" || props.currentUser.persona.name =="StorefrontAdministrator")) {
                    if (!(p.displayName.includes('Sales')) || props.currentUser.persona.name !== "CustomerAdministrator") {

                        list.push({ value: p.id, name: p.name, label: p.displayName, sortOrder: p.sortOrder, roles:p.personaRoles });
                    }
                }
            });
            setPersonaList(list);
            // if selected Persona is not in "list", clear out selected value.
            let p = list.find(l => l.value === selectedPersona.value);
            if (!p) {
                p = {
                    value: '', label: '', name: '', sortOrder: '', roles: {} };
                setSelectedPersona(p);
            }
            props.updateStorefrontPersona(selectedStorefront, p);
        });
    }

    function storefrontOnChange(e) {
        setSelectedStorefront(e);
    }

    function personaOnChange(e) {
        setSelectedPersona(e);
        props.updateStorefrontPersona(selectedStorefront, e);
    }

    return (
        <div className="w-100 d-flex justify-content-between">
            <div style={{ width: '48%' }}>
                <div className="label">
                    Storefront:
                </div>
                <Select options={storefrontOptions} onChange={storefrontOnChange} value={selectedStorefront} isDisabled={isCustAdmin}
                    className={props.errors && props.errors.selectedStorefront ? 'error-input' : ''}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                />
            </div>
            <div style={{ width: '48%' }}>
                <div className="label">
                    Persona:
                </div>
                <Select options={personaList} onChange={personaOnChange} value={selectedPersona}
                    className={props.errors && props.errors.selectedPersona ? 'error-input' : ''}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                />
            </div>
        </div>);
}

StorefrontPersona.defaultProps = {
    errors: {}
};
export default StorefrontPersona;